import { useRef } from 'react';
import { isDeepEqual } from 'remeda';

export const useDeepStable = <T>(value: T): T => {
    const ref = useRef<T>(value);
    if (!isDeepEqual(ref.current, value)) {
        ref.current = value;
    }
    return ref.current;
};
